import React from 'react';
import useStyles from './styles';

const NoAccess = (props) => {

  const { chartData } = props?.data
  const { messageInfo } = chartData

  const classes = useStyles();
  const info = messageInfo ? messageInfo : "Your current subscription doesn’t include this feature. Please contact the dSilo Customer Success team to upgrade your plan."

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.message}>{info}</div>
      </div>
    </div>
  );
};

export default NoAccess;
